module.exports = __webpack_public_path__ + "static/img/blog-1.d1695a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interthings/blog-1.jpg
// module id = VIFr
// module chunks = 4